import React from 'react';
import CustomImage from '../../../components/custom-image';

const GrievanceManagement = () => {
  return (
    <div className="accordion-body">
       <div className="tabel-wrapper">
        <div className="table mobile-img">
            <CustomImage
                className="custom-image"
                imageName="grievence-management.png"
                alt="GrievanceManagement"
                maxWidth="540"
            />
        </div>
      </div>
    </div>
  );
};

export default GrievanceManagement;